import { ForwardedRef, forwardRef } from 'react';
import ReactCurrencyInputField, {
  CurrencyInputProps,
} from 'react-currency-input-field';

const ReactCurrencyInput = forwardRef(
  (props: CurrencyInputProps, ref: ForwardedRef<HTMLInputElement>) => {
    return <ReactCurrencyInputField ref={ref} {...props} />;
  },
);

export default ReactCurrencyInput;
